// store Modules
import ui from './ui.js'
import auth from './auth.js'

export default {
    ui,
    auth
}